<template>
  <v-list align="center" class="nav-list">
    <v-menu
      v-for="(navItem, navKey) in navItems"
      :key="navKey"
      content-class="submenu"
      transition="slide-x-transition"
      location="right"
      offset="12">
      <template #activator="{ props }">
        <v-list-item
          v-bind="props"
          color="primary"
          :active="isActiveHeader(navItem)"
          class="px-0">
          <v-badge
            v-if="
              navKey === 'research' &&
              researchStudioStore.unreadSurveyIds?.length > 0
            "
            color="accent"
            offset-x="2"
            offset-y="8"
            dot>
            <v-fab
              variant="text"
              size="small"
              rounded="circle"
              :icon="navItem.icon" />
          </v-badge>
          <v-fab
            v-else
            variant="text"
            size="small"
            rounded="circle"
            :icon="navItem.icon" />
          <div>{{ navKey.replace(/-/g, " ") }}</div>
        </v-list-item>
      </template>
      <v-list class="py-0" rounded="xl">
        <v-list-item
          v-for="item in navItem.items"
          :key="item.title"
          color="primary"
          :class="{ 'pendo-dc-open': item.route?.name === 'download_center' }"
          :active="isActive(item)"
          :base-color="item.color"
          @click="$emit('navigate', item)">
          <template #title>
            {{ item.title }}
            <v-icon
              v-if="
                item?.route?.name === 'research_studio' &&
                researchStudioStore.unreadSurveyIds?.length > 0
              "
              size="x-small"
              color="accent"
              class="ml-1">
              mdi-circle
            </v-icon>
          </template>
        </v-list-item>
      </v-list>
    </v-menu>
  </v-list>
</template>

<script>
import { useResearchStudioStore } from "@/stores/ResearchStudioStore";
import { mapStores } from "pinia";
export default {
  name: "NavExpanded",
  props: {
    navItems: {
      type: Object,
      required: true,
    },
    isActiveHeader: {
      type: Function,
      required: true,
    },
    isActive: {
      type: Function,
      required: true,
    },
  },
  emits: ["navigate"],
  computed: {
    ...mapStores(useResearchStudioStore),
  },
};
</script>

<style lang="scss" scoped>
.nav-list {
  div {
    font-size: 11px;
    text-transform: capitalize;
  }
  :deep(.v-fab .v-btn) {
    pointer-events: none;
  }
}
:deep(.submenu) {
  .v-list-item {
    font-family: Barlow, sans-serif;
    color: rgb(var(--v-theme-prominent));
    .v-list-item__prepend {
      width: 20px;
    }
    .v-list-item-title {
      font-size: 14px;
      line-height: 20px;
      letter-spacing: 0.1px;
    }
  }
}
</style>
